<template>
    <ns-modal
        v-model="dialog"
        :fullscreen="fullScreen"
        :title="txc.hu_tax_info.hu_edit_tax_info"
        @input="closeDialog"
    >

        <section>
            <p>{{ txc.hu_tax_info.hu_tax_description }}</p>
            <br />
            <a v-if="languageLoggedIn === 'hu'" href="https://test.nuskin.com/content/dam/account/HU/hu_HUTaxDescription.pdf">{{ txc.hu_tax_info.card_title_hu_tax }} PDF</a>
            <a v-if="languageLoggedIn === 'en'" href="https://test.nuskin.com/content/dam/account/HU/en_HUTaxDescription.pdf">{{ txc.hu_tax_info.card_title_hu_tax }} PDF</a>
        </section>
        <server-error v-if="!!dialogError" :error="dialogError" />

        <v-form ref="taxInfoForm" v-model="taxInfoForm" @submit.prevent>
            <div class="field-label">{{txc.hu_tax_info.hu_tax_login}}</div>
            <v-text-field
                v-model="login"
                type="text"
                :rules="[ruleSet.isValidTaxLogin]"
            />
            <div class="field-label">{{txc.hu_tax_info.hu_tax_password}}</div>
            <v-text-field
                v-model="password"
                type="text"
                :rules="[ruleSet.isValidTaxPassword]"
            />
            <div class="field-label">{{txc.hu_tax_info.hu_tax_xml_signature}}</div>
            <v-text-field
                v-model="xmlSignatureKey"
                type="text"
                :rules="[ruleSet.isValidTaxXMLSignature]"
                @blur="formatXmlSignature"
            />
            <div class="field-label">{{txc.hu_tax_info.hu_tax_xml_exchange}}</div>
            <v-text-field
                v-model="xmlExchangeKey"
                type="text"
                :rules="[ruleSet.isValidTaxXMLExchange]"
            />
        </v-form>

        <template v-slot:actions>
            <v-layout column>
                <v-flex xs12>
                    <button
                        flat
                        block
                        class="primary-hit mb-2 fluid"
                        :disabled="!taxInfoForm || !login.length || !password.length || !xmlExchangeKey.length || !xmlSignatureKey.length"
                        @click="editTaxInfo"
                    >{{sharedStrings.generic.save}}</button>
                </v-flex>
                <v-spacer/>
                <v-flex xs12>
                    <button
                        flat
                        outline
                        block
                        class="secondary-hit fluid"
                        @click="closeDialog"
                    >{{sharedStrings.generic.cancel}}</button>
                </v-flex>
            </v-layout>
        </template>
    </ns-modal>    
</template>

<script>
import { NsModal } from '@nuskin/design-components';
import ServerError from '../ServerError';
import * as ruleSet from '../../repositories/globalRules.js';
import { mapGetters, mapActions } from 'vuex';
import { ProfileService } from '@nuskin/ns-account';

export default {
    components: {
        NsModal,
        ServerError
    },
    data: function() {
        return {
            ruleSet,
            dialog: true,
            dialogError: null,
            taxInfoForm: false,
            login: '',
            password: '',
            xmlSignatureKey: '',
            xmlExchangeKey: ''
        }
    },
    computed: {
        ...mapGetters({
            txc: 'translationsPersonal',
            sharedStrings: 'sharedStrings',
            languageLoggedIn: 'languageLoggedIn',
            fullScreen: 'mobileView',
            account: 'account',
            huTaxInfo: 'huTaxInfo'
        })
    },
    mounted() {
        this.login = this.huTaxInfo.LOGIN;
        this.password = this.huTaxInfo.PASS;
        this.xmlSignatureKey = this.huTaxInfo.XML_SIG;
        this.xmlExchangeKey = this.huTaxInfo.XML_EXCH;
    },
    methods: {
        ...mapActions(['updateHUTaxInfo']),
        closeDialog() {
            this.$emit('closeDialog');
            this.dialogError = null;
        },
        editTaxInfo () {
            let taxInfo = {'custom':[
                {
                    'type': 'HUTAX',
                    'key': 'LOGIN',
                    'value': this.login
                },
                {
                    'type': 'HUTAX',
                    'key': 'PASS',
                    'value': this.password
                },
                {
                    'type': 'HUTAX',
                    'key': 'XML_SIG',
                    'value': this.xmlSignatureKey
                },
                {
                    'type': 'HUTAX',
                    'key': 'XML_EXCH',
                    'value': this.xmlExchangeKey
                }
            ]
            }
            this.account.custom = taxInfo.custom;
            ProfileService.updateAccountInfo(taxInfo).then((res)=>{
                if (res.status === 200) {
                    this.updateHUTaxInfo({
                        LOGIN: this.login,
                        PASS: this.password,
                        XML_SIG: this.xmlSignatureKey,
                        XML_EXCH: this.xmlExchangeKey
                    });
                }
                this.closeDialog();
            })
        },
        formatXmlSignature() {
            if (!this.xmlSignatureKey.includes('-') && this.xmlSignatureKey.length === 30) {
                this.xmlSignatureKey = this.xmlSignatureKey.substr(0,2) + '-' + this.xmlSignatureKey.substr(2,4) + '-' + this.xmlSignatureKey.substr(6);
            }
        }
    }
}
</script>

<style lang="sass" scoped>
    
</style>